export type CalendarMode = 'week' | 'month';

export function isWeekend(date: Date): boolean {
  const d = date.getDay();
  return d === 0 || d === 6;
}

export function isSameDay(a: Date, b: Date): boolean {
  return (
    a.getFullYear() === b.getFullYear() &&
    a.getMonth() === b.getMonth() &&
    a.getDate() === b.getDate()
  );
}

export function startOfMonth(date: Date): Date {
  return new Date(date.getFullYear(), date.getMonth(), 1);
}

export function addMonths(date: Date, delta: number): Date {
  return new Date(date.getFullYear(), date.getMonth() + delta, 1);
}

export function startOfCalendarGrid(month: Date): Date {
  const first = startOfMonth(month);
  const day = first.getDay();
  const mondayBased = (day + 6) % 7; // 0..6 where 0 = Monday
  const start = new Date(first);
  start.setDate(first.getDate() - mondayBased);
  return start;
}

export function buildMonthGrid(month: Date): Date[] {
  const start = startOfCalendarGrid(month);
  const days: Date[] = [];
  for (let i = 0; i < 42; i += 1) {
    const d = new Date(start);
    d.setDate(start.getDate() + i);
    days.push(d);
  }
  return days;
}
